<script setup lang="ts">
    import CreateAccount from "@/components/auth/forms/CreateAccount.vue";
    import { usePage } from "@inertiajs/vue3";
    import { computed } from "vue";

    const message = computed(() => {
        return usePage()?.props?.flash?.message ?? {
            type: null,
        };
    });
</script>

<template>
    <div>
        <div
            v-if="message.type"
            style="margin-bottom: 1rem;"
            :class="{
                notification: true,
                'notification-success': message.type == 'success',
                'notification-error': message.type == 'error',
            }"
        >
            <p class="paragraph-details">{{ message.message }}</p>
        </div>
        <CreateAccount />
    </div>
</template>

<style scoped></style>
